import React from 'react';
import { useAuthStore } from 'src/store/auth';

export const HumanReviewStep: React.FC = () => {
  const { user } = useAuthStore();
  const displayName = user?.firstName || user?.username || 'user';

  return (
    <div className="p-6 h-full relative flex flex-col items-center justify-center max-lg:min-h-80 overflow-hidden text-center">
      <h3 className="text-4xl xl:text-6xl font-extrabold">{displayName}, your application needs further review.</h3>
      <p className="text-[18px] xl:text-[22px] leading-6 px-7 py-6 w-fit rounded-2xl">Thanks for submitting your application! We’re doing a quick additional review. While we check, your application is <strong>
        read-only</strong>—no edits to dependents, plans, or pricing. We’ll let you know as soon as it’s ready.</p>
    </div>
  );
};
